/* eslint-disable react/prop-types */
import React from 'react';
import { default as MediaAsset } from '@fiverr-private/cms_ui/src/content_types/MediaAsset/component/MediaAsset';
import './styles.scss';
import { SocialGrid } from './SocialGrid';

export const MediaGallery = (props) => {
    if (props.collage) {
        return <SocialGrid mediaAssets={props.mediaAssets} />;
    }

    return (
        <div className="seven-cards-container">
            {(props.mediaAssets || []).map((media, index) => (
                <div className="seven-cards-card" key={index}>
                    <MediaAsset {...media} />
                </div>
            ))}
        </div>
    );
};
